import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal, Alert } from 'react-bootstrap';
import ProjectDetail from '../../components/project_detail/ProjectDetail';
import { editProject } from '../../redux/projects/projects_actions';
import { isFollowupReferenceProject } from '../../utils/converter';

class ProjectEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.projectDetail = null;

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isEditing !== this.props.isEditing && !nextProps.isEditing && !nextProps.errorMessage) {
      this.props.onHide();
    }
  }

  onSaveHandler() {
    if (isFollowupReferenceProject(this.props.project)) return;
    const editedProject = this.projectDetail.getWrappedInstance().getWrappedInstance().getProjectData();
    const { location } = editedProject;
    const { id } = this.props.project;
    this.props.editProject(id, { ...editedProject, latitude: location.lat, longitude: location.lng });
  }

  render() {
    const { isEditing, errorMessage, editProject, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    const followupLocked = isFollowupReferenceProject(this.props.project);
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('edit project')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {followupLocked && (
            <Alert bsStyle="warning" style={{ marginBottom: 16 }}>
              {t('followup project read only notice')}
            </Alert>
          )}
          <ProjectDetail
            fieldErrors={errorMessage}
            project={this.props.project}
            disabled={followupLocked}
            ref={ref => (this.projectDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            onSubmit={() => !followupLocked && !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          {!followupLocked && (
            <Button
              id="project-submit-edit"
              disabled={!isSubmittable || isEditing}
              onClick={() => this.onSaveHandler()}
            >
              {isEditing ? `${t('saving')}...` : t('save')}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isEditing: state.project.editing,
  errorMessage: state.project.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  editProject: (id, project) => dispatch(editProject(id, project)),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ProjectEditModal)
);



// WEBPACK FOOTER //
// ./src/modal/projects/ProjectEditModal.js